import {IThemeIcons} from '../architecture/sections/theme-icons.interface';
import {MobileMenuIcon} from './icons/mobile-menu.icon';
import {InfoIcon} from './icons/info.icon';
import {AddIcon} from './icons/add.icon';
import {BackIcon} from './icons/back.icon';
import {ForwardIcon} from './icons/forward.icon';
import {CloseIcon} from './icons/close.icon';
import {SafeZoneIcon} from './icons/safe-zone.icon';
import {HelpIcon} from './icons/help.icon';
import {TwoCharsIcon} from './icons/two-chars.icon';
import {EarthGlobeIcon} from './icons/earth-globe.icon';
import {TopGamesIcon} from './icons/live-arena-navbar/top-games.icon';
import {RouletteIcon} from './icons/live-arena-navbar/roulette.icon';
import {BlackjackIcon} from './icons/live-arena-navbar/blackjack.icon';
import {EliteLoungeIcon} from './icons/live-arena-navbar/elite-lounge.icon';
import {PokerIcon} from './icons/live-arena-navbar/poker.icon';
import {BaccaratIcon} from './icons/live-arena-navbar/baccarat.icon';
import {GameShowsIcon} from './icons/live-arena-navbar/game-shows.icon';
import {NewGamesIcon} from './icons/live-arena-navbar/new-games.icon';
import {LinkToOfferIcon} from "./icons/link-to-offer.icon";
import {LinkToOfferCloseIcon} from "./icons/link-to-offer-close.icon";
import {SourceOfFundsIcon} from "./icons/source-of-funds.icon";
import {ArrowsUpDownIcon} from "./icons/arrows-up-down.icon";
import {MegaphoneIcon} from "./icons/megaphone.icon";
import {ChipIcon} from "./icons/chip.icon";
import {SettingsIcon} from "./icons/settings.icon";
import {MuteIcon} from "./icons/live-arena-tile/mute.icon";
import {UnmuteIcon} from "./icons/live-arena-tile/unmute.icon";
import {ViewersIcon} from "./icons/live-arena-tile/viewers.icon";
import {BrokenLinkIcon} from "./icons/live-arena-tile/broken-link.icon";
import {TimeReminderIcon} from "./icons/time-reminder.icon";
import {TripleEightExclusiveIcon} from "./icons/live-arena-navbar/triple-eight-exclusive.icon";
import {PaymentsRedirectIcon} from "./icons/payments-redirect.icon";
import {LeftArrowIcon} from "./icons/live-arena-tile/left-arrow.icon";
import {RightArrowIcon} from "./icons/live-arena-tile/right-arrow.icon";
import {LocationIcon} from "./icons/location.icon";
import {SearchIcon} from './icons/search.icon';
import {BlogIcon} from './icons/side-menu/blog.icon';
import {HomeIcon} from './icons/side-menu/home.icon';
import {PromotionsIcon} from './icons/side-menu/promotions.icon';
import {SlotsIcon} from './icons/side-menu/slots.icon';
import {JackpotsIcon} from './icons/side-menu/jackpots.icon';
import {LiveCasinoIcon} from './icons/side-menu/live-casino.icon';
import {CasinoGamesIcon} from './icons/side-menu/casino-games.icon';
import {VipIcon} from './icons/side-menu/vip.icon';
import {NewGamesIcon as SideMenuNewGamesIcon} from './icons/side-menu/new-games.icon';
import {TripleEightCasinoIcon} from "./icons/side-menu/888casino.icon";
import {BlackjackIcon as SideMenuBlackjackIcon} from './icons/side-menu/blackjack.icon';
import {RouletteIcon as SideMenuRouletteIcon} from './icons/side-menu/roulette.icon';
import {GettingStartedIcon} from "./icons/side-menu/getting-started.icon";
import {BankingIcon} from "./icons/side-menu/banking.icon";
import {LiveChatIcon} from "./icons/side-menu/live-chat.icon";
import {DownloadAppIcon} from "./icons/side-menu/download-app.icon";
import {Club888Icon} from "./icons/side-menu/club888.icon";
import {PokerCircleIcon} from "./icons/side-menu/poker-circle.icon";
import {SportCircleIcon} from "./icons/side-menu/sport-circle.icon";
import {VideoPokerIcon} from "./icons/side-menu/video-poker.icon";
import {DepositIcon} from "./icons/side-menu/deposit.icon";
import {FreePlayIcon} from "./icons/freeplay.icon";
import {NotificationIcon} from "./icons/notifications.icon";
import {HelpIcon as SideMenuHelpIcon} from "./icons/side-menu/help.icon";
import {WarningSignIcon} from "./icons/warning-sign.icon";
import {USAMapIcon} from "./icons/usa-map.icon";
import {ScratchCardsIcon} from './icons/side-menu/scratch-cards.icon';
import {MobileMenuNoSearchIcon} from "./icons/mobile-menu-no-search.icon";
import {SpeedGamesIcon} from "./icons/live-arena-navbar/speed-games.icon";

export const ThemeDefaultIcons: IThemeIcons = {
    mobileMenuNoSearchIcon: MobileMenuNoSearchIcon,
    mobileMenuIcon: MobileMenuIcon,
    addIcon: AddIcon,
    infoIcon: InfoIcon,
    backIcon: BackIcon,
    forwardIcon: ForwardIcon,
    closeIcon: CloseIcon,
    safeZoneIcon: SafeZoneIcon,
    helpIcon: HelpIcon,
    twoCharsIcon: TwoCharsIcon,
    earthGlobeIcon: EarthGlobeIcon,
    topGamesIcon: TopGamesIcon,
    rouletteIcon: RouletteIcon,
    blackjackIcon: BlackjackIcon,
    eliteLoungeIcon: EliteLoungeIcon,
    pokerIcon: PokerIcon,
    baccaratIcon: BaccaratIcon,
    gameShowsIcon: GameShowsIcon,
    newGamesIcon: NewGamesIcon,
    linkToOfferIcon: LinkToOfferIcon,
    linkToOfferCloseIcon: LinkToOfferCloseIcon,
    sourceOfFundsIcon: SourceOfFundsIcon,
    arrowsUpDownIcon: ArrowsUpDownIcon,
    megaphoneIcon: MegaphoneIcon,
    chipIcon: ChipIcon,
    settingsIcon: SettingsIcon,
    muteIcon: MuteIcon,
    unmuteIcon: UnmuteIcon,
    viewersIcon: ViewersIcon,
    brokenLinkIcon: BrokenLinkIcon,
    timeSpentReminderClockIcon: TimeReminderIcon,
    tripleEightExclusiveIcon: TripleEightExclusiveIcon,
    paymentsRedirectIcon: PaymentsRedirectIcon,
    leftArrowIcon: LeftArrowIcon,
    rightArrowIcon: RightArrowIcon,
    locationIcon: LocationIcon,
    searchIcon: SearchIcon,

    sideMenuHome: HomeIcon,
    sideMenuBlog: BlogIcon,
    sideMenuPromotions: PromotionsIcon,
    sideMenuSlots: SlotsIcon,
    sideMenuJackpots: JackpotsIcon,
    sideMenuLiveCasino: LiveCasinoIcon,
    sideMenuVip: VipIcon,
    sideMenuNewGames: SideMenuNewGamesIcon,
    sideMenuCasinoGames: CasinoGamesIcon,
    sideMenuExclusive888: TripleEightCasinoIcon,
    sideMenuScratchCards: ScratchCardsIcon,
    sideMenuBlackjack: SideMenuBlackjackIcon,
    sideMenuRoulette: SideMenuRouletteIcon,
    sideMenuGettingStarted: GettingStartedIcon,
    sideMenuBanking: BankingIcon,
    sideMenuLiveChat: LiveChatIcon,
    sideMenuDownloadApp: DownloadAppIcon,
    sideMenuClub888: Club888Icon,
    sideMenuPokerCircle: PokerCircleIcon,
    sideMenuSportCircle: SportCircleIcon,
    sideMenuVideoPoker: VideoPokerIcon,
    sideMenuDeposit: DepositIcon,
    notificationIcon: NotificationIcon,
    freeplayIcon: FreePlayIcon,
    sideMenuHelp: SideMenuHelpIcon,
    warningSignIcon: WarningSignIcon,
    usaMapIcon: USAMapIcon,
    speedGames: SpeedGamesIcon
};
